<h1 mat-dialog-title>Assign Booking Items</h1>
<mat-dialog-content fxLayout="column" fxLayoutGap="12px">
  <p>Select the item to be dispatched for this booking</p>
  <assign-items-table [booking]="booking" (itemFormArray)="setForm($event)"
    data-cy="assign-items-table"></assign-items-table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" [disabled]="disabled$ | async" (click)="saveItems()"
    data-cy="assign-items-save-button">
    Save
  </button>
</mat-dialog-actions>